import { render, staticRenderFns } from "./ApprovalComplete.vue?vue&type=template&id=e905d146&scoped=true&"
import script from "./ApprovalComplete.vue?vue&type=script&lang=js&"
export * from "./ApprovalComplete.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalComplete.vue?vue&type=style&index=0&id=e905d146&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e905d146",
  null
  
)

export default component.exports